import styled from 'styled-components';

export const MultiThreadingWrapper = styled.div`
.text-align-justify{
    text-align: justify;
}
.entry-title {
    font-weight: 600;
    font-size: 1.9rem;
    text-align: center;
}
.text-align-center{
    text-align: center;
}
p, li {
    color: #334155;
}
p, li {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #334155;
}
img {
    box-sizing: border-box;
    height: auto;
    max-width: 100%;
    vertical-align: bottom;
}
`;
